<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div
        class="email-app-sidebar sidebar-content card show"
      >
        <b-card
          class="card-transaction "
          no-body
        >
          <b-card-header>
            Encuestados
            <!-- <b-card-title>
              <b-input-group class="input-group-merge">
                <b-input-group-append is-text>
                  <span>Encuestados</span>
                </b-input-group-append>
                <b-input-group-append is-text>
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    target="_blank"
                    :href="`${publicPath}FORMATOS/IMPORTARBENEFICIARIOS.xlsx`"
                    variant="outline-primary"
                    class="btn-icon"
                    style="margin-right: 5px"
                  >
                    <feather-icon icon="DownloadIcon" />
                  </b-button>
                </b-input-group-append>
                <b-input-group-append is-text>
                  <label
                    v-b-tooltip.hover.top="titleImportarParcela"
                    for="file"
                    class="btn btn-outline-success"
                  >
                    <feather-icon
                      icon="FileTextIcon"
                      class="mr-50"
                    />
                    <span
                      v-show="isBusyImport===true"
                    >
                      Cargando...
                    </span>
                    <span
                      v-show="isBusyImport===false"
                    >
                      Importar
                    </span>
                  </label>
                </b-input-group-append>
              </b-input-group>
            </b-card-title> -->
          </b-card-header>
        </b-card>
        <!-- ScrollArea: Chat & Contacts -->
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="chat-user-list-wrapper list-group scroll-area"
        >
          <div
            v-if="isBusy"
            class="text-center text-primary my-2"
          >
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
          <ul class="chat-users-list chat-list media-list">
            <component
              :is="tag"
              v-for="(encuest, index) in itemsEncuestado.items"
              :key="'ficha-' + encuest.encuestado.idEncuestado"
              class="li-ficha"
              :class="{'active': activeEncuestadoId === encuest.encuestado.idEncuestado}"
              @click="$emit('open-ficha', encuest.encuestado.idEncuestado)"
            >
              <b-avatar
                square
                size="42"
                :src="`data:image/jpeg;base64,${encuest.encuestado.foto}`"
                badge
                class="badge-minimal"
                badge-variant="success"
                variant="transparent"
              />
              <div class="chat-info flex-grow-1">
                <h5 class="mb-0">
                  {{ encuest.encuestado.nombre }}
                </h5>
                <p class="card-text text-truncate mb-0">
                  {{ encuest.encuestado.apellidoPaterno }} {{ encuest.encuestado.apellidoMaterno }}
                </p>
                <p class="card-text">
                  {{ encuest.encuestado.documento }}
                </p>
              </div>
              <b-dropdown
                variant="link"
                no-caret
                class="chart-dropdown"
                toggle-class="p-0"
                right
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="18"
                    class="text-body cursor-pointer"
                  />
                </template>
                <b-dropdown-item
                  v-show="false"
                  @click="$emit('open-modal-edit-ficha', itemsEncuestado.items[index], 'opClick'); $emit('close-left-sidebar')"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Editar</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-show="false"
                  @click="$emit('delete-ficha', itemsEncuestado.items[index], 'opClick')"
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Eliminar</span>
                </b-dropdown-item>
              </b-dropdown>
            </component>
          </ul>
        </vue-perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import {
  ref,
  // ref, watch, computed, onUnmounted,
} from '@vue/composition-api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  BAvatar, BCard, BCardHeader, BInputGroup, BInputGroupAppend, VBTooltip, BCardTitle, BCardBody, BButton, BDropdown, BDropdownItem, BListGroup, BListGroupItem, BBadge, BSpinner,
} from 'bootstrap-vue'
import { isDynamicRouteActive } from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {

    // BSV
    BAvatar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BDropdown,
    BDropdownItem,
    BListGroup,
    BListGroupItem,
    BBadge,
    BInputGroup,
    BSpinner,
    BInputGroupAppend,
    // 3rd Party
    VuePerfectScrollbar,
  },
  props: {
    activeEncuestadoId: {
      type: Number,
      default: null,
    },
  },
  setup() {
    const isBusy = ref(false)
    const tag = ref('li')
    const itemsEncuestado = ref({})
    const titleFormatoEncuestado = ref('')
    const publicPath = ref(process.env.BASE_URL)
    const displayFicha = require('@/assets/images/palmas/ficha.png')
    const titleImportarParcela = ref('')
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
    }

    const getFichas = async () => {
      isBusy.value = true
      await store
        .dispatch('gsencuesta/ENCUESTADO_FIND_ALL', {
          limit: 50,
          query: '',
          page: 1,
          sortBy: 'idDetalleEncuestadoFicha%7CDESC',
        })
        .then(response => {
          itemsEncuestado.value = response
        })
        .catch(error => {
          this.showError(error)
          this.isBusyS = false
        })
      isBusy.value = false
    }

    getFichas()

    const resolveAvatar = etapa => {
      if (etapa === 1) {
        return require('@/assets/images/palmas/ficha.png')
      }
      return require('@/assets/images/palmas/fichaclose.png')
    }

    const updateCantFichas = (idFicha, cant) => {
      const indexFicha = itemsEncuestado.value.items.findIndex(f => f.idEncuestado === idFicha)
      itemsEncuestado.value.items[indexFicha].cantReclutados = cant
    }

    const resolveBadge = etapa => {
      if (etapa === 1) {
        return 'success'
      }
      return 'secondary'
    }

    const emailFilters = [
      { title: 'Inbox', icon: 'MailIcon', route: { name: 'apps-email' } },
      { title: 'Sent', icon: 'SendIcon', route: { name: 'apps-email-folder', params: { folder: 'sent' } } },
      { title: 'Draft', icon: 'Edit2Icon', route: { name: 'apps-email-folder', params: { folder: 'draft' } } },
      { title: 'Starred', icon: 'StarIcon', route: { name: 'apps-email-folder', params: { folder: 'starred' } } },
      { title: 'Spam', icon: 'InfoIcon', route: { name: 'apps-email-folder', params: { folder: 'spam' } } },
      { title: 'Trash', icon: 'TrashIcon', route: { name: 'apps-email-folder', params: { folder: 'trash' } } },
    ]

    const emailLabel = [
      { title: 'Personal', color: 'success', route: { name: 'apps-email-label', params: { label: 'personal' } } },
      { title: 'Company', color: 'primary', route: { name: 'apps-email-label', params: { label: 'company' } } },
      { title: 'Important', color: 'warning', route: { name: 'apps-email-label', params: { label: 'important' } } },
      { title: 'Private', color: 'danger', route: { name: 'apps-email-label', params: { label: 'private' } } },
    ]

    const resolveFilterBadgeColor = filter => {
      if (filter === 'Draft') return 'light-warning'
      if (filter === 'Spam') return 'light-danger'
      return 'light-primary'
    }

    const getDateFmt = fecha => {
      const fmt = 'DD/MM/YYYY  HH:mm:ss'
      return moment(String(fecha)).format(fmt)
    }

    return {
      // UI
      perfectScrollbarSettings,
      isDynamicRouteActive,
      resolveFilterBadgeColor,

      // Filter & Labels
      emailFilters,
      emailLabel,

      // Fichas
      isBusy,
      resolveAvatar,
      resolveBadge,
      tag,
      displayFicha,
      getDateFmt,
      getFichas,
      itemsEncuestado,
      updateCantFichas,
      titleFormatoEncuestado,
      publicPath,
      titleImportarParcela,
    }
  },
}
</script>

<style>

</style>
